import { useEffect, useState } from 'react';

declare const HSThemeAppearance: {
  init: () => void;
  setAppearance: (theme: string) => void;
};

interface ThemeOption {
  value: string;
  label: string;
  icon: string;
  iconClass: string;
}

const themeOptions: ThemeOption[] = [
  {
    value: 'auto',
    label: 'Sistema',
    icon: 'icon-light',
    iconClass: 'bi bi-pc-display-horizontal me-2 fs-4 text-primary fw-bolder',
  },
  {
    value: 'default',
    label: 'Claro',
    icon: 'icon-light',
    iconClass: 'bi bi-sun-fill me-2 fs-4 text-primary fw-bolder',
  },
  {
    value: 'dark',
    label: 'Oscuro',
    icon: 'icon-dark',
    iconClass: 'bi bi-moon-stars-fill me-2 fs-4 text-primary fw-bolder',
  },
];

const ThemeDropdown = () => {
  const [selectedTheme, setSelectedTheme] = useState<string>('');
  const [selectedLabel, setSelectedLabel] = useState<string>('Apariencia');
  const [selectedIconClass, setSelectedIconClass] = useState<string>('');

  const handleThemeSelect = (option: ThemeOption) => {
    setSelectedTheme(option.value);
    setSelectedLabel(option.label);
    setSelectedIconClass(option.iconClass);
    localStorage.setItem('theme', option.value);
    localStorage.setItem('themeLabel', option.label);
    localStorage.setItem('themeIcon', option.iconClass);
  };

  useEffect(() => {
    const savedTheme = localStorage.getItem('theme');
    const savedLabel = localStorage.getItem('themeLabel');
    const savedIcon = localStorage.getItem('themeIcon');

    if (savedTheme) {
      setSelectedTheme(savedTheme);
      setSelectedLabel(savedLabel || 'Apariencia');
      setSelectedIconClass(savedIcon || '');
    }
  }, []);

  useEffect(() => {
    if (selectedTheme && typeof HSThemeAppearance !== 'undefined') {
      HSThemeAppearance.init();
      HSThemeAppearance.setAppearance(selectedTheme);
    }
  }, [selectedTheme]);

  return (
    <div className="dropdown">
      <button
        type="button"
        id="selectThemeDropdown"
        aria-expanded="false"
        className="navbar-dropdown-submenu-item dropdown-item dropdown-toggle"
        data-bs-toggle="dropdown"
      >
        {selectedIconClass && <i className={`${selectedIconClass} me-2`} />}
        {selectedLabel}
      </button>
      <div
        aria-labelledby="selectThemeDropdown"
        className="dropdown-menu dropdown-menu-end navbar-dropdown-menu navbar-dropdown-menu-borderless navbar-dropdown-sub-menu"
      >
        {themeOptions.map((option) => (
          <button
            key={option.value}
            type="button"
            className={`dropdown-item${selectedTheme === option.value ? ' active' : ''}`}
            onClick={() => handleThemeSelect(option)}
          >
            <i className={option.iconClass} /> {option.label}
          </button>
        ))}
      </div>
    </div>
  );
};

export default ThemeDropdown;
